import { TableColumn } from '@/typing';
import { slotList } from '@/components/page-model/mjstore/mjstore-cardrecord-config';
import { get_is_active, get_is_delete, getDate, getDateTime, toFixed0 } from '@/utils/function';
export default (current_org: any) => {
  const None = null;
  const True = true;
  const False = false;
  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '卡号',
      width: 190,
      dataIndex: 'order_code',
      checked: true,
    },
    {
      title: '诉求号',
      width: 170,
      dataIndex: 'require_info__code',
      checked: true,
    },
    {
      title: '会籍门店',
      width: 150,
      dataIndex: 'customer__shop__name',
      checked: true,
    },
    {
      title: '会员编号',
      width: 140,
      dataIndex: 'customer__code',
      checked: true,
    },
    {
      title: '会员姓名',
      width: 110,
      dataIndex: 'customer__name',
      checked: true,
    },
    {
      title: '项目类别',
      width: 100,
      dataIndex: 'card__project_type__name',
      checked: true,
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '生美项目', value: '生美项目' },
        { text: '医美项目', value: '医美项目' },
        { text: '养发项目', value: '养发项目' },
        { text: '康养项目', value: '康养项目' },
      ],
    },
    {
      title: '卡名称',
      width: 130,
      dataIndex: 'card__name',
      checked: true,
    },
    {
      title: '到期日期',
      width: 100,
      dataIndex: 'end_date',
      checked: true,

      content: (record: any, text: any) => {
        return getDate(text);
      },
    },

    {
      title: '卡余次',
      width: 75,
      dataIndex: 'now_num',
      checked: true,
    },
    {
      title: '耗卡次数',
      width: 80,
      dataIndex: 'used_num',
      checked: true,
    },
    {
      title: '撤卡次数',
      width: 80,
      dataIndex: 'cancel_num',
      checked: true,
    },
    {
      title: '卡次数',
      width: 75,
      dataIndex: 'total_num',
      checked: true,
    },
    {
      title: '单价',
      width: 75,
      dataIndex: 'single_price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '卡金额',
      width: 75,
      dataIndex: 'price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '充值使用金额',
      width: 110,
      dataIndex: 'czje',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '返利使用金额',
      width: 110,
      dataIndex: 'flje',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '直接返利',
      width: 110,
      dataIndex: 'zjfl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '赠券使用金额',
      width: 110,
      dataIndex: 'zjje',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '促销政策',
      width: 110,
      dataIndex: 'cxzc__name',
      checked: true,
    },
    {
      title: '转卡来源',
      width: 260,
      dataIndex: 'kzk_from',
      checked: true,
    },
    {
      title: '备注',
      width: 300,
      dataIndex: 'mark',
      checked: true,
    },
    {
      title: '所属顾问',
      width: 150,
      dataIndex: 'customer__adviser__name',
      checked: true,
    },
    {
      title: '执行门店',
      width: 75,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '执行人',
      width: 75,
      dataIndex: 'staff__name',
      checked: true,
    },
    {
      title: '购卡日期',
      width: 150,
      dataIndex: 'date',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '创建日期',
      width: 135,
      dataIndex: 'create_time',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '激活状态',
      width: 135,
      dataIndex: 'used_status',
      checked: true,
      content: (record: any, text: any) => {
        let content = '';
        switch (text) {
          case 0:
            content = '未激活';
            break;
          case 1:
            content = '待激活';
            break;
          case 2:
            content = '已激活';
            break;
          default:
            content = '';
            break;
        }
        return content;
      },
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '未激活', value: 0 },
        { text: '待激活', value: 1 },
        { text: '已激活', value: 2 },
      ],
    },
    {
      title: '执行情况',
      width: 150,
      dataIndex: 'is_now_num',
      checked: true,
      cellComponent: 'boolean',
      name1: '待执行',
      name2: '执行完',
      filterMultiple: false,
      filters: [
        { text: '待执行', value: true },
        { text: '执行完', value: false },
      ],
      content: (record: any, text: any) => {
        const dict: any = {
          true: '待执行',
          false: '执行完',
        };
        return dict[text];
      },
    },
    {
      title: '单据状态',
      width: 150,
      dataIndex: 'is_delete',
      checked: true,
      cellComponent: 'boolean',
      name1: '已作废',
      name2: '未作废',
      color1: 'red',
      color2: 'green',
      filterMultiple: false,
      filters: [
        { text: '未作废', value: false },
        { text: '已作废', value: true },
      ],
      content: (record: any, text: any) => {
        return get_is_delete(text);
      },
    },
    {
      title: '确认日期',
      width: 135,
      dataIndex: 'receipt_datetime',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '操作',
      width: 240,
      dataIndex: 'action',
      checked: true,
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push({
    type: 'custom',
    slotName: 'is_now_num',
    field_true: '待执行',
    field_false: '执行完',
  });
  newSlotList.push(
    {
      type: 'custom',
      slotName: 'card_type',
      field_0: '次卡',
      field_1: '月卡',
      field_3: '季卡',
      field_12: '年卡',
    },
    {
      type: 'custom',
      slotName: 'used_status',
      field_0: '未激活',
      field_1: '待激活',
      field_2: '已激活',
    },
    { type: 'custom', slotName: 'is_delete', field_true: '已作废', field_false: '未作废' },
  );

  return {
    baseColumns: baseColumns,
    newSlotList: newSlotList,
  };
};
